<div class="table-border">
    <div>
        <div class="table-header">
            <div class="section-title">
                {{'PYMES.COBERTURAS.PRINCIPALES' | translate}}
            </div>
            <div class="text" *ngFor="let item of principales; let i = index">
                <span class="section-heading__icon" aria-hidden="true">
                    <span class="section-heading__check">✓</span>
                </span>
                <h5>{{item}}</h5>
            </div>
        </div>
    </div>
    <div>
        <div class="table-header">
            <div class="section-title">
                {{'PYMES.COBERTURAS.DIFERENCIALES' | translate}}
            </div>
            <div class="text" *ngFor="let item of diferenciales; let i = index">
                <span class="section-heading__icon" aria-hidden="true">
                    <span class="section-heading__check">✓</span>
                </span>
                <h5>{{item}}</h5>
            </div>
        </div>
    </div>
</div>
<section class=" mt-4">
    <div class="float-left">
        <button ca-button (click)="goBack()">
            {{ 'MAIN.BOTON_VOLVER' | translate }}
        </button>
    </div>
</section>